const short = date => new Intl.DateTimeFormat('en-US', {
  month: 'long',
  day: 'numeric',
  timeZone: 'UTC',
}).format(new Date(date));

export default { short };
